import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  font-size: 12px;
  line-height: 160%; /* 19.2px */
  color: var(--Schemes-Surface-On-surface-On-Surface-Variant-2, #69757d);
  padding: 0px 12px;
`

export const OpenFoodFactLink = styled.a`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  color: var(--Schemes-Surface-On-surface-On-Surface-Variant-2, #69757d);
`

const OpenFoodFactDescription = () => {
  return (
    <Wrapper>
      Contains information from{" "}
      <OpenFoodFactLink href="https://world.openfoodfacts.org/" target="_blank">
        Open Food Facts
      </OpenFoodFactLink>
      , which is made available here under the{" "}
      <OpenFoodFactLink
        href="https://opendatacommons.org/licenses/odbl/1-0/"
        target="_blank"
      >
        Open Database License (ODbL).
      </OpenFoodFactLink>
    </Wrapper>
  )
}

export default OpenFoodFactDescription
